import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Drawer } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';
import { Contents } from './Contents';

export type ApprovalRouteDrawerProps = {
  open: boolean;
  onClose: () => void;
  reportId: string;
  onCloseDetailDrawer: () => void;
};

export const ApprovalRouteDrawer: FC<ApprovalRouteDrawerProps> = memo(
  ({ open, onClose, reportId, onCloseDetailDrawer }) => {
    const containerRef = useGlobalContainerRef();
    const { t } = useTranslation();
    return (
      <Drawer
        visible={open}
        width={600}
        onClose={onClose}
        title={t('approving_invoice_reports.approval_route')}
        getContainer={containerRef}
        mask
      >
        <Contents
          reportId={reportId}
          onCloseDetailDrawer={onCloseDetailDrawer}
        />
      </Drawer>
    );
  }
);
ApprovalRouteDrawer.displayName = 'ApprovalRouteDrawer';
